var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRemoveTab = function SvgRemoveTab(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10251"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#c7c7c7",
    stroke: "#fff",
    strokeWidth: 2,
    "data-name": "Ellipse 333",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 12,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    "data-name": "Component 27 \\u2013 517"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#7d2853",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "m10 10 10.281 10.624",
    "data-name": "Line 206"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#7d2853",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M20.281 10 10 20.624",
    "data-name": "Line 207"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z",
    "data-name": "Rectangle 4603"
  })))));
};
export default SvgRemoveTab;